import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-2 w-full mt-4" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-semibold" }, " Two–factor authentication ", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", null, "You can enable two-factor authentication using an authenticator app such as Google Authenticator", -1);
const _hoisted_4 = {
    key: 0,
    class: "error-text"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("iframe", {
    src: "/two-factor-form",
    class: "w-full h-full border-none",
    referrerpolicy: "same-origin"
}, null, -1);
const _hoisted_6 = { class: "flex w-full justify-end" };
import { ref } from 'vue';
import Button from 'primevue/button';
import Modal from '@apparatix/Components/Modal.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TwoFactorAuthentication',
    props: {
        isTwoFactorEnabled: { type: Boolean }
    },
    setup(__props) {
        const showManageModal = ref(false);
        const handleCloseModal = () => showManageModal.value = false;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                (!_ctx.isTwoFactorEnabled)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Two–factor authentication is not currently active. Enabling two–factor provides your account with an additional layer of security, and is recommended for all users "))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    _createVNode(_unref(Button), {
                        label: _ctx.isTwoFactorEnabled ? 'Manage two-factor' : 'Enable two-factor authentication',
                        onClick: _cache[0] || (_cache[0] = ($event) => (showManageModal.value = true))
                    }, null, 8, ["label"])
                ]),
                _createVNode(Modal, {
                    visible: showManageModal.value,
                    "on-close": handleCloseModal,
                    title: "Manage two-factor authentication"
                }, {
                    body: _withCtx(() => [
                        _hoisted_5
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(Button), {
                                label: "Cancel",
                                severity: "secondary",
                                onClick: handleCloseModal
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["visible"])
            ]));
        };
    }
});
